import { useContext, useMemo } from 'react';
import { useDateFormat } from '../useDateFormate';
import { useStatusRenderer } from '../useStatus';
import eye from "../../../assets/image/eye.png";
import edit from "../../../assets/image/edit2.png";
import { useNavigate } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ApproveButton from '../../../assets/image/ApproveButton';
import {
    ADMIN_EXECUTIVE_ID, ADMIN_MANAGER_ID, DRAFT_ID, FINANCE_ID,
    FINANCE_PENDING, PETTY_CASH_APPROVE_ID, SUPER_ADMIN_ID,
    VENDOR_MANAGER_PENDING, VENDOR_REJECT, VENDOR_VP_PENDING, VP_ID
} from '../../constant';
import { ModalContext } from '../../Context';
import RejectButton from '../../../assets/image/RejectButton';
import { BILL_NUMBER, CREATE_DATE } from './TableHeader';
import ApproveModal from '../../../components/modal/ApproveModal';
import RejectionModal from '../../../components/modal/RejectionModal';
import Alert from '../../../components/modal/Alert';
import { PENDING_DETAILS_MESSAGE } from '../globalErrorMessage';

export const usePettyCashColumns = (handlerPettyCashList, pageNumber, pageSize, globalSearch, billStatusId, billType) => {
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem("userData"));
    const modalContext = useContext(ModalContext);
    const { handleModalData } = modalContext;

    const handlerView = (id) => {
        navigate(`/view-petty-cash/${id}`);
    }

    const handlerApprove = (data) => {
        let app = <ApproveModal
            data={data}
            handlerList={handlerPettyCashList}
            pageNumber={pageNumber}
            pageSize={pageSize}
            globalSearch={globalSearch}
            type={PETTY_CASH_APPROVE_ID}
            billStatusId={billStatusId}
        />;
        handleModalData(app, "md");
    }

    const handleReject = (data) => {
        let reject = <RejectionModal
            data={data}
            handlerPettyCashList={handlerPettyCashList}
            pageNumber={pageNumber}
            pageSize={pageSize}
            globalSearch={globalSearch}
            billStatusId={billStatusId}
            billType={data.BillType}
        />;
        handleModalData(reject, "md");
    }

    const editPettyCashBill = (data) => {
        if (data?.VendorStatus === VENDOR_MANAGER_PENDING && data?.IsSelfService === true) {
            let alert = <Alert message={PENDING_DETAILS_MESSAGE} />;
            handleModalData(alert, "md");
        } else {
            navigate(`/edit-petty-cash/${data.id}`);
        }
    }

    const showEditButton = (data) => {
        const isDraft = data.Status === DRAFT_ID;
        const isRejected = data.Status === VENDOR_REJECT;
        const isPendingManager = data.Status === VENDOR_MANAGER_PENDING;

        const hasEditPermission = (
            (isDraft && (user.RoleId === ADMIN_EXECUTIVE_ID || user.RoleId === ADMIN_MANAGER_ID)) ||
            ((isRejected || (isPendingManager && user.RoleId === ADMIN_MANAGER_ID)) &&
                (user.RoleId !== VP_ID && user.RoleId !== FINANCE_ID && user.RoleId !== SUPER_ADMIN_ID))
        );

        return hasEditPermission;
    }

    const columns = useMemo(() => [
        {
            Header: BILL_NUMBER,
            accessor: "DocumentNo",
        },
        {
            Header: "Vendor Name",
            accessor: "VendorName",
            Cell: ({ row }) => {
                return <>Prospect Vendor</>;
            },
        },
        {
            Header: CREATE_DATE,
            accessor: "CreatedAt",
            Cell: ({ row }) => {
                return <> {useDateFormat(row.original.CreatedAt)}</>;
            },
        },
        {
            Header: "Bill Date",
            accessor: "BillDate",
            Cell: ({ row }) => {
                return <> {useDateFormat(row.original.BillDate)}</>;
            },
        },
        {
            Header: <div className='ms-auto'>Grand Total</div>,
            accessor: "Total",
            Cell: ({ row }) => {
                return <> <div className='text-end'>{row?.original?.CurrencySymbol} {row?.original?.Total?.toFixed(2)}</div> </>;
            },
        },
        {
            Header: <div className='m-auto'>Status</div>,
            accessor: "StatusName",
            Cell: ({ row }) => useStatusRenderer(row),
            disableSortBy: true,
        },
        {
            Header: "Action",
            accessor: (data) => {
                return (
                    <div className="d-flex align-item-center w-100">
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip className="custom-tooltip cstm-tooltip" id="tooltips1">
                                    View
                                </Tooltip>
                            }
                        >
                            <img src={eye} alt="" onClick={() => handlerView(data.id)} className='cursor-pointer' />
                        </OverlayTrigger>

                        {(
                            data.Status !== DRAFT_ID && (
                                (data.Status === VENDOR_MANAGER_PENDING && user.RoleId === ADMIN_MANAGER_ID) ||
                                (data.Status === VENDOR_VP_PENDING && user.RoleId === VP_ID) ||
                                (data.Status === FINANCE_PENDING && user.RoleId === FINANCE_ID)
                            )
                        ) && (
                                <span className="d-flex">
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip className="custom-tooltip cstm-tooltip" id="tooltips3">
                                                Approve
                                            </Tooltip>
                                        }
                                    >
                                        <span
                                            onClick={() => handlerApprove(data)}
                                            className="cursor-pointer cstm-icon-gap"
                                        >
                                            <ApproveButton />
                                        </span>
                                    </OverlayTrigger>

                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip className="custom-tooltip cstm-tooltip" id="tooltips4">
                                                Reject
                                            </Tooltip>
                                        }
                                    >
                                        <span
                                            onClick={() => handleReject(data)}
                                            className="cursor-pointer cstm-icon-gap"
                                        >
                                            <RejectButton />
                                        </span>
                                    </OverlayTrigger>
                                </span>
                            )}

                        {showEditButton(data) && (
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip className="custom-tooltip cstm-tooltip" id="tooltips5">
                                        Edit
                                    </Tooltip>
                                }
                            >
                                <img
                                    src={edit}
                                    alt=""
                                    onClick={() => editPettyCashBill(data)}
                                    className="cstm-icon-gap cursor-pointer"
                                />
                            </OverlayTrigger>
                        )}
                    </div>
                );
            },
            disableSortBy: true,
        },
    ], [handlerPettyCashList, pageNumber, pageSize, globalSearch, user]);

    return columns;
};
